// extracted by mini-css-extract-plugin
export default {"container":"AuthText_container__+jdBk","error":"AuthText_error__Ch1OW"};